<!--
 * @Date: 2020-08-20 11:13:13
 * @Author: MX
 * @LastEditTime: 2022-07-05 09:14:07
 * @Description: 初始页面
-->
<template>
  <div id="app">
    <Header></Header>
    <div class="us">
      <el-popover placement="left" :open-delay="200" :offset="20" popper-class="cupopper" title="" width="200" trigger="hover">
        <div class="us-item" slot="reference">
          <div class="cricle us-icon"></div>
          <div class="us-font">联系我们</div>
        </div>
        <div>
          <span style="color: #E60000">扫码添加客服飞书</span>
          <img style="width:150px;height:150px" src="./assets/images/newHome/phoneus.jpg" alt="联系我们">
          <div style="color: #E60000;width: 150px">工作日8:30-18:00</div>
        </div>
      </el-popover>
      <div class="us-item" @click="top" :style="{ visibility: isTop ? 'visible' : 'hidden' }">
        <div class="cricle top"></div>
        <div class="us-font">回到顶部</div>
      </div>
    </div>
    <router-view/>
  </div>
</template>
<script>
import Header from "./views/home/NewHeader"

export default {
  name: 'App',
  components: { 
      Header,
  },
  data() {
    return {
      isTop: false,
      scrollTop: 0,
      timer: null,
      downScroll: false
    }
  },
  mounted() {
    // 向页面添加股东事件
    window.addEventListener('scroll', this.handleScroll, true)
    window.addEventListener('wheel', this.moveWheel, false);
  },
  watch: {
    '$route.path': {
      deep: true,
      handler() {
        document.documentElement.scrollTop = 0
      }
    }
  },
  methods:{
    moveWheel(e) {
      let timerWheel = null;
      e = window.event;
      if (e.wheelDelta < 0) {
        this.downScroll = true;
      }
      clearTimeout(timerWheel);
      timerWheel = setTimeout(() => {
        this.downScroll = false;
      }, 200);
    },
    top() {
      clearInterval(this.timer);
      this.timer = setInterval(()=>{
        var temp = this.scrollTop / 10
        temp = temp > 0 ? Math.ceil(temp) : Math.floor(temp)
        if (this.scrollTop === 0 || this.downScroll) {
          clearInterval(this.timer)
        }
        document.documentElement.scrollTop = this.scrollTop - temp;
      },10)
    },
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const windowHeight = document.body.clientHeight
      this.isTop = this.scrollTop / windowHeight * 100 > 35 ? true : false
    }
  }
}
</script>
<style lang="scss">
.cupopper {
  width: 150px !important;
  height: 200px !important;
}
</style>
<style lang="scss" scoped>
.us {
  z-index: 500;
  position: fixed;
  right: 10px;
  bottom: 200px;
  .cricle {
    width: 45px;
    height: 45px;
    background-color: rgba(230, 0, 0, 0.5);
    border-radius: 50%;
    margin-bottom: 5px;
  }
  .top {
    background: rgba(230, 0, 0, 0.65) url("./assets/images/newHome/top.png") no-repeat center center;
    background-size: 20px 20px;
  }
  .us-icon {
    background: rgba(230, 0, 0, 0.65) url("./assets/images/newHome/us.png") no-repeat center center;
    background-size: 30px 30px;
  }
  .us-item {
    margin: 20px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .us-item:hover {
    cursor: pointer;
    color: #E60000;
    .cricle {
      background-color: rgba(230, 0, 0, 1);
      box-shadow: 0 0px 5px 0 rgba(230, 0, 0, 1)
    }
  }
  .us-font {
    font-size: 14px;
    font-weight: 400;
    color: #E60000;
  }
}
</style>
<style lang="scss">
@import "./assets/iconfontNew/iconfont.css";
@import "./assets/iconfont/iconfont.css";
#app{
    height: 100%;
}
$bg: rgba(0, 0, 0, 0.1);
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
/*滚动条小方块*/
::-webkit-scrollbar-thumb {
  background-color: #B2B2B2;
  -webkit-border-radius: 5px; /* Safari 和 Chrome */
  -moz-border-radius: 5px; /* Firefox */
  -o-border-radius: 5px; /* Opera */
  border-radius: 5px;
}
/*滚动轨道两端按钮*/
::-webkit-scrollbar-button {
  -webkit-box-shadow: inset 0 0 5px $bg;
  background-color: $bg;
}
/*滚动轨道 内阴影*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px $bg;
  background-color: $bg;
}
</style>
